module.exports = __webpack_public_path__ + "static/media/txt.c9663bc3.svg";